// extracted by mini-css-extract-plugin
export default {"header":"styles_header__SUUlb","header_wrapper":"styles_header_wrapper__8Vyqu","link":"styles_link__yOu3e"};